import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { compose, withPropsOnChange } from 'recompose';
import lazyLoad from "../enhancers/lazyLoad";
import { getApplicationStagesAction } from "../../api/jsonapi";
var optionParser = function optionParser(list) {
  var label_param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var with_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  try {
    return list.map(function (e) {
      var value = e.id;
      var label = e.attributes[label_param];
      if (with_id) {
        label = "".concat(value, ": ").concat(label);
      }
      return {
        label: label,
        value: value
      };
    });
  } catch (e) {
    // Empty
  }
  return [];
};
var optionValueParser = function optionValueParser(list) {
  var label_param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var with_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  try {
    return list.map(function (e) {
      var value = e.attributes.value;
      var label = e.attributes[label_param];
      if (with_id) {
        label = "".concat(value, ": ").concat(label);
      }
      return {
        label: label,
        value: value
      };
    });
  } catch (e) {
    // Empty
  }
  return [];
};
var enhancer = compose(lazyLoad('applicationStages', getApplicationStagesAction), withPropsOnChange(['applicationStages'], function (_ref) {
  var applicationStages = _ref.applicationStages,
    useValue = _ref.useValue;
  return {
    applicationStagesOptions: useValue ? optionValueParser(applicationStages) : optionParser(applicationStages)
  };
}));
export default enhancer;